

function EmailLink(props) {

    return (
        <>
        <a href={`mailto:${props.recepcao}`}>{props.recepcao}</a>
        <a href={`mailto:${props.secretaria}`}>{props.secretaria}</a>
        <a href={`mailto:${props.secretaria2}`}>{props.secretaria2}</a>
        <a href={`mailto:${props.atendimento}`}>{props.atendimento}</a>
        <a href={`mailto:${props.atendimento2}`}>{props.atendimento2}</a>
        <a href={`mailto:${props.homologacao}`}>{props.homologacao}</a>
        <a href={`mailto:${props.homologacao2}`}>{props.homologacao2}</a>
        <a href={`mailto:${props.informatica}`}>{props.informatica}</a>
        <a href={`mailto:${props.informatica2}`}>{props.informatica2}</a>
        </>
        
    );
}

export default EmailLink;